export default definePayloadPlugin(() => {
  ;(definePayloadReviver('CaseStudyPayloadReducer', (data) => JSON.parse(data)),
    definePayloadReducer(
      'CaseStudyPayloadReducer',
      (data) => data && typeof data === 'object' && 'toJSON' in data && JSON.stringify(data.toJSON())
    ))
})
